import {Outlet} from 'react-router-dom'
import {Box} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import {AppBar} from '../components/AppBar'
import {useAuth} from '../modules/auth/hooks/useAuth'
import {actions} from '../modules/auth/AuthRedux'
import {useAppDispatch} from '../components/hooks/useAppDispatch'
import {useOnMount} from '../components/hooks/useOnMount'
import {useState} from 'react'

// TODO: If user is logged in, navigate to first accessible page of the user.

export const RootRoute = () => {
  const {user} = useAuth()
  const dispatch = useAppDispatch()
  const [isLoading, setIsLoading] = useState(true)

  useOnMount(() => {
    if (user) {
      dispatch(actions.validateToken()).finally(() => {
        setIsLoading(false)
      })
    } else {
      setIsLoading(false)
    }
  })

  return (
    <>
      <AppBar />
      {isLoading ? (
        <Box
          sx={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Outlet />
      )}
    </>
  )
}
